import { tableIcons } from '../../../../constants/assets'
import type { BookingRecord } from '../../../../types'

type RouteCellProps = {
  service: BookingRecord['service']
  route: BookingRecord['route']
}

/** Service name over the "from -> to" pair, separated by the ringed arrow badge. */
export const RouteCell = ({ service, route }: RouteCellProps) => (
  <div className="flex flex-col items-start gap-[4px]">
    <span className="h-[19px] truncate font-host text-[14px] font-medium leading-normal text-black">
      {service}
    </span>

    {/* <span className="flex items-start gap-[2px] font-host text-[14px] font-normal leading-normal text-dash-cell-faint">
      <span className="whitespace-nowrap">{route.from}</span>

      <span aria-hidden className="relative block h-[17.363px] w-[17.547px] shrink-0">
        <img alt="" className="block size-full max-w-none" src={tableIcons.routeRing} />
        <span className="absolute left-[3.73px] top-[3.69px] block h-[10.344px] w-[10.453px] overflow-hidden">
          <span className="absolute bottom-[21.3%] left-[7.04%] right-[7.01%] top-[21.3%] block -scale-y-100">
            <img alt="" className="block size-full max-w-none" src={tableIcons.routeArrow} />
          </span>
        </span>
      </span>

      <span className="truncate">{route.to}</span>
    </span> */}
  </div>
)
